export const ROLES = {
  Viewer: "Viewer",
  Explorer: "Explorer",
  Creator: "Creator",
  Admin: "Admin",
  Guest: "Guest",
};
